// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"47deeb12","397":"40a72cb6"}[chunkId] + ".chunk.js";
};